import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyManagersSellWrong from './components/WhyManagersSellWrong';
import WhyNeedsAnalysisMatters from './components/WhyNeedsAnalysisMatters';
import SkillsLearned from './components/SkillsLearned';
import TypicalMistakes from './components/TypicalMistakes';
import CaseResults from './components/CaseResults';
import HowTrainingGoes from './components/HowTrainingGoes';
import PracticeOverTheory from './components/PracticeOverTheory';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import Formats from './components/Formats';
import SuitableCompanies from './components/SuitableCompanies';
import AboutAuthor from './components/AboutAuthor';
import CTASection from './components/CTASection';
import FinalCTA from './components/FinalCTA';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';

const seoNavLinks = [
  { label: 'Программа', target: 'program' },
  { label: 'Кейсы', target: 'cases' },
  { label: 'Форматы', target: 'formats' },
  { label: 'FAQ', target: 'faq' },
];

export default function NeedsAnalysisTrainingPage() {
  return (
    <>
      
      <SeoTitle title="Выявление потребностей клиента | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={seoNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhyManagersSellWrong />
        <WhyNeedsAnalysisMatters />
        <SkillsLearned />
        <TypicalMistakes />
        <CaseResults />
        <HowTrainingGoes />
        <PracticeOverTheory />
        <WhyProgramsWork />
        <CompanyResults />
        <Formats />
        <SuitableCompanies />
        <AboutAuthor />
        <CTASection />
        <FinalCTA />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}